import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  address: {},
};

const addressSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    setPickedAddress: (state, action) => {
      state.address = action.payload;
    },
  },
});

export const { setPickedAddress } = addressSlice.actions;
export default addressSlice.reducer;
